import { useQuery } from '@tanstack/react-query'
import { getBookingServices } from '../services/bookingsService'

export function useServices() {
  return useQuery({
    queryKey: ['services'],
    queryFn: () => getBookingServices(),
    staleTime: 10 * 60 * 1000,
  })
}
